import '@/fe/extend';
import dayjs from 'dayjs';
import { isNull, isUndefined, isNumber } from '@/fe/utils';
import calc from '@/fe/calc';
/**
 * 通用状态字典 过滤器 将键值转换为label显示
 * @param value key
 * @param dictList 字典数组
 */
export const valueToLabel = function (value: string | number, dictList: any[]): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  let item = dictList.filter(el => el.value.toString() === value.toString());
  if (item.length > 0) {
    return item[0].label;
  } else {
    return value as unknown as string;
  }
};
/**
 * 通用状态字典 过滤器 将键值转换为label显示
 * @param value key
 * @param dictList 字典数组
 */
export const dictEscape = function (value: string | number, dictList: any[]): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  let item = dictList.filter(el => el.value.toString() === value.toString());
  if (item.length > 0) {
    return item[0].label;
  } else {
    return value as unknown as string;
  }
};

/**
 * 千分位 过滤器 用于金额 (不管整数还是小数 按照fillZero要求补零)
 * @param value key
 * @param precision 保留几位小数
 * @param fillZero 实际小数位小于precision时 是否补零
 * @param separator 分隔符
 */
export const thousands = function (value: number | string, precision: number = 2, fillZero: boolean = true, separator: string = ','): string {
  let num: number = Number(value);

  // 判断是否为数字
  if (isNumber(num) && !Number.isNaN(num)) {
    let numStr = '';
    if (isNumber(precision)) {
      if (fillZero) {
        numStr = calc.toFixed(value, precision);
      } else {
        let decimals: string | number = String(num).split('.')[1];
        decimals = decimals ? decimals.length : 0;
        if (decimals > precision) {
          decimals = precision;
        }
        numStr = calc.toFixed(value, decimals).toString();
      }
    } else {
      numStr = num.toString();
    }
    let parts = numStr.split('.');
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));
    return parts.join('.');
  }
  return value as unknown as string;
};
export const thousandsMoney = thousands;

/**
 * 数字 过滤器 用于非金额的数字 (如果是整数不补零 如果是小数按照precision要求补零)
 * @param value key
 * @param precision 保留几位小数
 * @param separator 分隔符
 */
export const thousandsNumber = function (value: number | string, precision: number = 2, separator: string = ','): string {
  let num: number = Number(value);

  // 判断是否为数字
  if (isNumber(num) && !Number.isNaN(num)) {
    let numStr = '';
    if (isNumber(precision)) {
      if (!Number.isInteger(num)) {
        numStr = calc.toFixed(value, precision);
      } else {
        let decimals: string | number = String(num).split('.')[1];
        decimals = decimals ? decimals.length : 0;
        if (decimals > precision) {
          decimals = precision;
        }
        numStr = calc.toFixed(value, decimals).toString();
      }
    } else {
      numStr = num.toString();
    }
    let parts = numStr.split('.');
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));
    return parts.join('.');
  }
  return value as unknown as string;
};

/**
 * 数字精确位数 过滤器
 * @param value key
 * @param precision 保留几位小数
 * @param fillZero 实际小数位小于precision时 是否补零
 */
export const toFixed = function (value: string | number, precision: number = 2, fillZero: boolean = true): string {
  let num: number = Number(value);
  if (isNumber(num)) {
    if (isNumber(precision)) {
      if (fillZero) {
        return calc.toFixed(value, precision);
      } else {
        let decimals: string | number = String(num).split('.')[1];
        decimals = decimals ? decimals.length : 0;
        if (decimals > precision) {
          decimals = precision;
        }
        return calc.toFixed(value, decimals);
      }
    } else {
      return num.toFixedNew(2);
    }
  }
  return value as unknown as string;
};

/**
 * 时间差转换 倒计时 过滤器
 * @param value key
 */
export const countDown = function (value: number): string {
  if (isNumber(value)) {
    if (value == 0) {
      return '00:00:00';
    }
    const hour = Math.floor(value / 3600);
    const minute = Math.floor((value - hour * 3600) / 60);
    const second = Math.floor(value - hour * 3600 - minute * 60);
    const hourStr = hour < 10 ? '0' + hour : hour;
    const minuteStr = minute < 10 ? '0' + minute : minute;
    const secondStr = second < 10 ? '0' + second : second;
    return hourStr + ':' + minuteStr + ':' + secondStr;
  } else {
    return value as unknown as string;
  }
};

/**
 * 时间转换过滤器 依赖dayjs
 * @param value key
 * @param format 格式化样式YYYY-MM-DD HH:mm:ss.SSS A (dayjs的format)
 */
export const dateFormat = function (value: string | number, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  if (value === 0 || value === '0') return '';

  if (!dayjs(value).isValid()) return '';
  return dayjs(value).format(format);
};

/**
 * 银行卡脱敏打*号 只展示后几位
 * @param value key
 * @param endLen 尾部保留显示位数
 * @param total 银行卡脱敏替换后总长度
 */
export const bankSen = function (value: string, endLen: number = 4, total: number = 16): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  let xing = '';
  for (var i = 0; i < total - endLen; i++) {
    xing += '*';
  }
  return xing + value.substr(value.length - 4);
};

/**
 * 身份证脱敏打*号
 * @param value
 * @param frontLen 开头保留位数
 * @param endLen 尾部保留位数
 */
export const idCardSen = function (value: string, frontLen: number = 4, endLen: number = 4): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  if (value) {
    var len = value.length - frontLen - endLen;
    var xing = '';
    for (var i = 0; i < len; i++) {
      xing += '*';
    }
    return value.substring(0, frontLen) + xing + value.substring(value.length - endLen);
  } else {
    return '';
  }
};

/**
 * 金额转大写
 * @param value key
 */
export const bigMoney = function (value: string | number): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  value = Number(value);
  if (!isNumber(value)) {
    return value as unknown as string;
  }
  if (value === 0) {
    return '零元整';
  }
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  const head = value < 0 ? '欠' : '';
  value = Math.abs(value);
  let s = '';
  for (let m = 0; m < fraction.length; m++) {
    s += (digit[Math.floor(calc.multiply(value, 10 * Math.pow(10, m))) % 10] + fraction[m]).replace(/零./, '');
  }
  s = s || '整';
  value = Math.floor(value);
  for (let i = 0; i < unit[0].length && value > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && value > 0; j++) {
      p = digit[value % 10] + unit[1][j] + p;
      value = Math.floor(value / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  );
};

/**
 * 将逗号分隔的字符串转为制定格式
 * @示例 splitFormat("1,2,3,4","个月",",")  转换结果为=>1个月,2个月,3个月,4个月
 * @param value key
 * @param addstr 拼接字符
 * @param separator 分割字符
 */
export const splitFormat = function (value: string, addstr: string = '', separator: string = ','): string {
  if (value === '' || isNull(value) || isUndefined(value)) {
    return value as unknown as string;
  }
  let arr = value.split(separator);
  arr = arr.map(el => el + addstr);
  return arr.join(',');
};
